export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_FAILED = 'FETCH_USER_FAILED'
export const FETCH_USER_SUCCEEDED = 'FETCH_USER_SUCCEEDED'
